

export class NpApiResult {
  public Errors: string[];
  public Results: any;
  public Warnings: string[];
}
